<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col-md-8 left">
          <div class="title">
            {{ $t('sidebar.companyinfo') }}
          </div>
        </div>
        <div class="col-md-4 right">
          <div class="action"/>
        </div>
      </div>
    </div>

    <div class="content col-md-12">
      <p v-if="!ready">{{ $t('message.loading') }}</p>

      <!-- <pre>{{ form }}</pre> -->
      <!-- <pre>{{ dataSetContacts }}</pre> -->

      <template v-if="!edited && ready">
        <div class="click-to-shake">
          <section>
            <div class="col-md-12 no-padding">
              <section-header :title="$t('message.general')"/>
              <div class="form-row">
                <div class="col-md-12">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <label>{{ $t('message.logo') }}</label>
                      <div class="row">
                        <div class="col-12">
                          <div style="width: 100%;position: relative;/*background: rgba(216, 226, 231, .25);*/">
                            <template>
                              <img
                                v-if="shopInfo.logo.original"
                                :src="shopInfo.logo.original"
                                class="col-12 img-thumbnail"
                                style="padding: 5px;max-width: 158px;">
                              <img
                                v-else
                                :src="defaultImages.product"
                                class="col-12 img-thumbnail"
                                style="padding: 5px;max-width: 158px;">
                            </template>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col-md-12">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <label>{{ $t('message.shopname') }} *</label>
                      <input
                        v-model="form.shop_name"
                        type="text"
                        class="form-control"
                        disabled>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section>
            <div class="col-md-12 no-padding">
              <section-header :title="$t('message.business')"/>
              <div class="form-row">
                <div class="col-md-6">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <label>{{ $t('message.form') }}</label>
                      <select
                        v-model="form.info.business.form_id"
                        class="custom-select form-control"
                        disabled>
                        <option value="">{{ $t('placeholder.select') }}</option>
                        <option value="1">{{ $t('business.form.1') }}</option>
                        <option value="2">{{ $t('business.form.2') }}</option>
                        <!-- <option value="3">{{ $t('business.form.3') }}</option> -->
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <label>{{ $t('message.type') }}</label>
                      <select
                        v-model="form.info.business.type_id"
                        class="custom-select form-control"
                        disabled>
                        <option value="">{{ $t('placeholder.select') }}</option>
                        <option
                          v-if="form.info.business.form_id == 1"
                          value="1">{{ $t('business.type.1') }}</option>
                        <option
                          v-if="form.info.business.form_id == 1"
                          value="2">{{ $t('business.type.2') }}</option>
                        <option
                          v-if="form.info.business.form_id == 1"
                          value="3">{{ $t('business.type.3') }}</option>
                        <option
                          v-if="form.info.business.form_id == 1"
                          value="4">{{ $t('business.type.4') }}</option>
                        <option
                          v-if="form.info.business.form_id == 1"
                          value="5">{{ $t('business.type.5') }}</option>
                        <option
                          v-if="form.info.business.form_id == 1"
                          value="6">{{ $t('business.type.6') }}</option>
                        <option
                          v-if="form.info.business.form_id == 1"
                          value="7">{{ $t('business.type.7') }}</option>
                        <option
                          v-if="form.info.business.form_id == 1"
                          value="8">{{ $t('business.type.8') }}</option>
                        <option
                          v-if="form.info.business.form_id == 1"
                          value="9">{{ $t('business.type.9') }}</option>
                        <option
                          v-if="form.info.business.form_id == 1"
                          value="10">{{ $t('business.type.10') }}</option>
                        <option
                          v-if="form.info.business.form_id == 1"
                          value="11">{{ $t('business.type.11') }}</option>
                        <option
                          v-if="form.info.business.form_id == 1"
                          value="12">{{ $t('business.type.12') }}</option>

                        <option
                          v-if="form.info.business.form_id == 2"
                          value="101">{{ $t('business.type.101') }}</option>
                        <option
                          v-if="form.info.business.form_id == 2"
                          value="102">{{ $t('business.type.102') }}</option>
                        <option
                          v-if="form.info.business.form_id == 2"
                          value="103">{{ $t('business.type.103') }}</option>

                        <option
                          v-if="form.info.business.form_id > 0"
                          value="300">{{ $t('business.type.300') }}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col-md-12">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <label>{{ $t('message.about') }}</label>
                      <b-form-textarea
                        :rows="3"
                        v-model="form.info.business.about"
                        disabled/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section>
            <div class="col-md-12 no-padding">
              <section-header :title="$t('message.vat')"/>
              <div class="form-row">
                <div class="col-md-6">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <label>{{ $t('message.vatregistration') }}</label>
                      <div class="box-input active">
                        <vs-checkbox
                          v-model="form.info.vat.is_active"
                          :disabled="true"
                          color="#A3CA76"
                          style="float: left;position: relative;top: 1px;left: -5px;">
                          <template>
                            <span v-if="form.info.vat.is_active">{{ $t('message.yes') }}</span>
                            <span v-else>{{ $t('message.no') }}</span>
                          </template>
                        </vs-checkbox>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <label>{{ $t('message.taxpayerno') }}</label>
                      <input
                        v-model="form.info.vat.taxpayer_no"
                        type="text"
                        class="form-control"
                        disabled>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section>
            <div class="col-md-12 no-padding">
              <section-header :title="$t('message.location')"/>
              <!-- <div class="form-row">
                <div class="col-md-12">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <label>{{ $t('message.map') }}</label>
                      <img class="img-fluid" src="https://i.imgur.com/fQYbBwa.png">
                    </div>
                  </div>
                </div>
              </div> -->
              <div class="form-row">
                <div class="col-md-12">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <label>{{ $t('message.country') }}</label>
                      <select
                        v-model="form.info.location.country_code"
                        class="custom-select form-control"
                        disabled>
                        <option value="">{{ $t('placeholder.select') }}</option>
                        <option value="TH">{{ $t('countries.th') }}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col-md-12">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <label>{{ $t('message.address') }}</label>
                      <b-form-textarea
                        :rows="3"
                        v-model="form.info.location.address"
                        disabled/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section>
            <div class="col-md-12 no-padding">
              <section-header :title="$t('message.contacts')"/>
              <div class="form-row">
                <div class="col-md-12">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <label>{{ $t('message.tel') }}</label>
                      <input
                        v-model="form.contacts.tel"
                        type="text"
                        class="form-control"
                        disabled>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col-md-12">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <label>{{ $t('message.email') }}</label>
                      <input
                        v-model="form.contacts.email"
                        type="text"
                        class="form-control"
                        disabled>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section>
            <div class="col-md-12 no-padding">
              <section-header :title="$t('message.socialmedia')"/>
              <div class="form-row">
                <div class="col-md-12">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <label>{{ $t('message.website') }}</label>
                      <input
                        v-model="form.contacts.website"
                        type="text"
                        class="form-control"
                        disabled>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col-md-12">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <label>{{ $t('socialmedia.facebook') }}</label>
                      <input
                        v-model="form.contacts.facebook"
                        type="text"
                        class="form-control"
                        disabled>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col-md-12">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <label>{{ $t('socialmedia.youtube') }}</label>
                      <input
                        v-model="form.contacts.youtube"
                        type="text"
                        class="form-control"
                        disabled>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </template>

      <template v-if="edited">
        <section>
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.general')"/>
            <div class="form-row">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-md-2">
                    <label>{{ $t('message.logo') }}</label>
                    <div class="row">
                      <div class="col-12">
                        <template>
                          <file-pond
                            v-if="form.isShowFilePond == true"
                            ref="pond"
                            :server="{process, revert, restore, load, fetch}"
                            name="file"
                            className="my-pond"
                            acceptedFileTypes="image/jpeg, image/png"
                            imagePreviewHeight="240"
                            imageCropAspectRatio="1:1"
                            labelIdle="อัพโหลดรูปภาพ"
                            labelTapToUndo=""
                            labelTapToCancel="คลิกเพื่อยกเลิก"
                            labelFileProcessing="กำลังอัปโหลด"
                            labelFileLoading="กำลังโหลด"
                            labelFileProcessingComplete=""
                            labelButtonRemoveItem="นำออก"
                            labelFileProcessingError="เกิดข้อผิดพลาด"
                            labelButtonAbortItemProcessing="ยกเลิก"
                            @init="handleFilePondInit"/>
                          <div
                            v-else
                            style="width: 158px;position: relative;">
                            <template>
                              <img
                                v-if="shopInfo.logo.original"
                                :src="shopInfo.logo.original"
                                class="col-12 img-thumbnail"
                                style="padding: 5px;max-width: 158px;">
                              <img
                                v-else
                                :src="defaultImages.product"
                                class="col-12 img-thumbnail"
                                style="padding: 5px;max-width: 158px;">
                            </template>
                            <div style="width: 100%; position: absolute; top: 5px; left: 0px; text-align: right;">
                              <button
                                class="btn btn-sm btn-close-image"
                                @click="closeImage()">
                                <i class="fas fa-times"/>
                              </button>
                            </div>
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label>{{ $t('message.shopname') }} *</label>
                    <input
                      ref="shopname"
                      :class="[class_.shop_name]"
                      v-model="form.shop_name"
                      type="text"
                      class="form-control"
                      @keyup="onkeyupShopname">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.business')"/>
            <div class="form-row">
              <div class="col-md-6">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label>{{ $t('message.form') }}</label>
                    <select
                      v-model="form.info.business.form_id"
                      class="custom-select form-control">
                      <option value="">{{ $t('placeholder.select') }}</option>
                      <option value="1">{{ $t('business.form.1') }}</option>
                      <option value="2">{{ $t('business.form.2') }}</option>
                      <!-- <option value="3">{{ $t('business.form.3') }}</option> -->
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label>{{ $t('message.type') }}</label>
                    <select
                      :disabled="form.info.business.form_id == ''"
                      v-model="form.info.business.type_id"
                      class="custom-select form-control">
                      <option value="">{{ $t('placeholder.select') }}</option>
                      <option
                        v-if="form.info.business.form_id == 1"
                        value="1">{{ $t('business.type.1') }}</option>
                      <option
                        v-if="form.info.business.form_id == 1"
                        value="2">{{ $t('business.type.2') }}</option>
                      <option
                        v-if="form.info.business.form_id == 1"
                        value="3">{{ $t('business.type.3') }}</option>
                      <option
                        v-if="form.info.business.form_id == 1"
                        value="4">{{ $t('business.type.4') }}</option>
                      <option
                        v-if="form.info.business.form_id == 1"
                        value="5">{{ $t('business.type.5') }}</option>
                      <option
                        v-if="form.info.business.form_id == 1"
                        value="6">{{ $t('business.type.6') }}</option>
                      <option
                        v-if="form.info.business.form_id == 1"
                        value="7">{{ $t('business.type.7') }}</option>
                      <option
                        v-if="form.info.business.form_id == 1"
                        value="8">{{ $t('business.type.8') }}</option>
                      <option
                        v-if="form.info.business.form_id == 1"
                        value="9">{{ $t('business.type.9') }}</option>
                      <option
                        v-if="form.info.business.form_id == 1"
                        value="10">{{ $t('business.type.10') }}</option>
                      <option
                        v-if="form.info.business.form_id == 1"
                        value="11">{{ $t('business.type.11') }}</option>
                      <option
                        v-if="form.info.business.form_id == 1"
                        value="12">{{ $t('business.type.12') }}</option>

                      <option
                        v-if="form.info.business.form_id == 2"
                        value="101">{{ $t('business.type.101') }}</option>
                      <option
                        v-if="form.info.business.form_id == 2"
                        value="102">{{ $t('business.type.102') }}</option>
                      <option
                        v-if="form.info.business.form_id == 2"
                        value="103">{{ $t('business.type.103') }}</option>

                      <option
                        v-if="form.info.business.form_id > 0"
                        value="300">{{ $t('business.type.300') }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label>{{ $t('message.about') }}</label>
                    <b-form-textarea
                      :rows="3"
                      v-model="form.info.business.about"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.vat')"/>
            <div class="form-row">
              <div class="col-md-6">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label>{{ $t('message.vatregistration') }}</label>
                    <div class="box-input">
                      <vs-checkbox
                        v-model="form.info.vat.is_active"
                        color="#A3CA76"
                        style="float: left;position: relative;top: 1px;left: -5px;">
                        <template>
                          <span v-if="form.info.vat.is_active">{{ $t('message.yes') }}</span>
                          <span v-else>{{ $t('message.no') }}</span>
                        </template>
                      </vs-checkbox>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label>{{ $t('message.taxpayerno') }}</label>
                    <input
                      v-model="form.info.vat.taxpayer_no"
                      type="text"
                      class="form-control">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.location')"/>
            <!-- <div class="form-row">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label>{{ $t('message.map') }}</label>
                    <img class="img-fluid" src="https://i.imgur.com/fQYbBwa.png">
                  </div>
                </div>
              </div>
            </div> -->
            <div class="form-row">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label>{{ $t('message.country') }}</label>
                    <select
                      v-model="form.info.location.country_code"
                      class="custom-select form-control">
                      <option value="">{{ $t('placeholder.select') }}</option>
                      <option value="TH">{{ $t('countries.th') }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label>{{ $t('message.address') }}</label>
                    <b-form-textarea
                      :rows="3"
                      v-model="form.info.location.address" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.contacts')"/>
            <div class="form-row">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label>{{ $t('message.tel') }}</label>
                    <input
                      v-model="form.contacts.tel"
                      type="text"
                      class="form-control">
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label>{{ $t('message.email') }}</label>
                    <input
                      v-model="form.contacts.email"
                      type="text"
                      class="form-control">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.socialmedia')"/>
            <div class="form-row">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label>{{ $t('message.website') }}</label>
                    <input
                      v-model="form.contacts.website"
                      type="text"
                      class="form-control">
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label>{{ $t('socialmedia.facebook') }}</label>
                    <input
                      v-model="form.contacts.facebook"
                      type="text"
                      class="form-control">
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label>{{ $t('socialmedia.youtube') }}</label>
                    <input
                      v-model="form.contacts.youtube"
                      type="text"
                      class="form-control">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="action-bar">
          <div
            v-if="!$store.state.app.loading"
            class="col-md-12 text-right">
            <!-- <button class="btn btn-light" @click="edited = false">{{ $t('button.cancel') }}</button> -->
            <button
              :disabled="disabled.btn_save"
              class="btn btn-web"
              @click="save()">{{ $t('button.save') }}</button>
          </div>
          <div
            v-if="$store.state.app.loading"
            class="col-md-12 text-right">
            <!-- <button class="btn btn-light" disabled>{{ $t('button.cancel') }}</button> -->
            <button
              class="btn btn-web"
              disabled>
              <i class="fas fa-spinner spin"/>
            </button>
          </div>
        </section>
      </template>

    </div>

    <BaseConfirmDiscardModal
      :show="confirmDiscardModal.show"
      @onCancel="handleDiscardCancleModal"
      @onConfirm="handleDiscardConfirmModal"
    />

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import sidebarModule from './../../sidebarModule'
import _ from 'lodash'
import discardFormMixin from '@/mixins/discardForm'

// Import Vue FilePond
import vueFilePond from 'vue-filepond'

// Import FilePond styles
import 'filepond/dist/filepond.min.css'

// Import FilePond plugins
// Please note that you need to install these plugins separately

// Import image preview plugin styles
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css'

// Import image preview and file type validation plugins
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import FilePondPluginImageCrop from 'filepond-plugin-image-crop'
import FilePondPluginImageResize from 'filepond-plugin-image-resize'
import FilePondPluginImageTransform from 'filepond-plugin-image-transform'

// Create component
const FilePond = vueFilePond(FilePondPluginFileValidateType,
  FilePondPluginImagePreview,
  FilePondPluginFileValidateSize,
  FilePondPluginImageCrop,
  FilePondPluginImageResize,
  FilePondPluginImageTransform)

export default {
  name: 'SettingsCompany',
  mixins: [discardFormMixin],
  data () {
    return {
      ready: false,

      edited: false,
      updated: false,

      form: {
        shop_name: '',
        logo: [{
          type: 'original',
          location: null,
        }, {
          type: 'thumbnail',
          location: null,
        }],
        info: {
          business: {
        		form_id: null,
        		type_id: null,
            about: null,
        	},
          vat: {
        		is_active: null,
        		taxpayer_no: null,
        	},
        	location: {
        		lat: null,
        		lng: null,
        		country_code: null,
        		address: null,
        	},
        },
        contacts: {
          email: null,
          tel: null,
          website: null,
          facebook: null,
          youtube: null,
        },
        isShowFilePond: false,
      },

      originalForm: null,

      class_: {
        shop_name: null,
      },

      disabled: {
        btn_save: false,
      },
    }
  },
  computed: {
    ...mapGetters({
      shopInfo: 'getShopInfo',
      getShopContact: 'getShopContact',
      getShopContactIdByPlatform: 'getShopContactIdByPlatform',
      defaultImages: 'getDefaultImages',
    }),
    IsValidform () {
      // check shop_name
      if (this.form.shop_name.trim().length == 0) {
        this.class_.shop_name = 'is-invalid'
      } else {
        this.class_.shop_name = null
      }
      return this.form.shop_name.trim().length > 0
    },
    dataSetContacts () {
      let dataSet = {}
      let shopInfo = this.shopInfo
      let form = this.form

      let shopInfoContact = this.getShopContact(shopInfo.contacts)

      dataSet['contacts'] = {
        'insert': [],
        'update': [],
        'delete': [],
      }

      if (shopInfoContact.email == null) {
        if (form.contacts.email !== shopInfoContact.email) {
          if (form.contacts.email.trim().length > 0) {
            dataSet['contacts'].insert.push({
              'platform': 'email',
              'source': form.contacts.email,
            })
          }
        }
      } else {
        if (form.contacts.email !== shopInfoContact.email) {
          if (form.contacts.email.trim().length > 0) {
            dataSet['contacts'].update.push({
              'contact_id': this.getShopContactIdByPlatform('email', shopInfo.contacts),
              'platform': 'email',
              'source': form.contacts.email,
            })
          } else {
            dataSet['contacts'].delete.push({
              'contact_id': this.getShopContactIdByPlatform('email', shopInfo.contacts),
            })
          }
        }
      }

      if (shopInfoContact.tel == null) {
        if (form.contacts.tel !== shopInfoContact.tel) {
          if (form.contacts.tel.trim().length > 0) {
            dataSet['contacts'].insert.push({
              'platform': 'tel',
              'source': form.contacts.tel,
            })
          }
        }
      } else {
        if (form.contacts.tel !== shopInfoContact.tel) {
          if (form.contacts.tel.trim().length > 0) {
            dataSet['contacts'].update.push({
              'contact_id': this.getShopContactIdByPlatform('tel', shopInfo.contacts),
              'platform': 'tel',
              'source': form.contacts.tel,
            })
          } else {
            dataSet['contacts'].delete.push({
              'contact_id': this.getShopContactIdByPlatform('tel', shopInfo.contacts),
            })
          }
        }
      }

      if (shopInfoContact.website == null) {
        if (form.contacts.website !== shopInfoContact.website) {
          if (form.contacts.website.trim().length > 0) {
            dataSet['contacts'].insert.push({
              'platform': 'website',
              'source': form.contacts.website,
            })
          }
        }
      } else {
        if (form.contacts.website !== shopInfoContact.website) {
          if (form.contacts.website.trim().length > 0) {
            dataSet['contacts'].update.push({
              'contact_id': this.getShopContactIdByPlatform('website', shopInfo.contacts),
              'platform': 'website',
              'source': form.contacts.website,
            })
          } else {
            dataSet['contacts'].delete.push({
              'contact_id': this.getShopContactIdByPlatform('website', shopInfo.contacts),
            })
          }
        }
      }

      if (shopInfoContact.facebook == null) {
        if (form.contacts.facebook !== shopInfoContact.facebook) {
          if (form.contacts.facebook.trim().length > 0) {
            dataSet['contacts'].insert.push({
              'platform': 'facebook',
              'source': form.contacts.facebook,
            })
          }
        }
      } else {
        if (form.contacts.facebook !== shopInfoContact.facebook) {
          if (form.contacts.facebook.trim().length > 0) {
            dataSet['contacts'].update.push({
              'contact_id': this.getShopContactIdByPlatform('facebook', shopInfo.contacts),
              'platform': 'facebook',
              'source': form.contacts.facebook,
            })
          } else {
            dataSet['contacts'].delete.push({
              'contact_id': this.getShopContactIdByPlatform('facebook', shopInfo.contacts),
            })
          }
        }
      }

      if (shopInfoContact.youtube == null) {
        if (form.contacts.youtube !== shopInfoContact.youtube) {
          if (form.contacts.youtube.trim().length > 0) {
            dataSet['contacts'].insert.push({
              'platform': 'youtube',
              'source': form.contacts.youtube,
            })
          }
        }
      } else {
        if (form.contacts.youtube !== shopInfoContact.youtube) {
          if (form.contacts.youtube.trim().length > 0) {
            dataSet['contacts'].update.push({
              'contact_id': this.getShopContactIdByPlatform('youtube', shopInfo.contacts),
              'platform': 'youtube',
              'source': form.contacts.youtube,
            })
          } else {
            dataSet['contacts'].delete.push({
              'contact_id': this.getShopContactIdByPlatform('youtube', shopInfo.contacts),
            })
          }
        }
      }

      return dataSet.contacts
    },
  },
  watch: {
    ready: function () {
      // loading finish
      this.showFinish(this.$Progress)
    },
    edited: function (after, before) {
      if (!this.edited && !this.updated) {
        this.form = _.cloneDeep(this.originalForm)
        this.IsValidform
      } else {
        this.updated = false
        this.setData()
      }
    },
    'form.info.business.form_id': {
      handler: function (after) {
        let val = after
        if (this.edited) {
          // this.form.info.business.type_id = ''
        }
      },
      deep: true,
    },
  },
  beforeCreate: function () {

  },
  created: function () {
    // setdata
    this.setData()
    // set ready
    this.ready = true
    // set edited
    this.edited = true
  },
  beforeMount: function () {
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.settings.title'),
      current: {
        app_name: 'settings',
        app_id: null,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 0,
    })
  },
  mounted: function () {

  },
  destroyed: function () {
    this.leavePage(this.$Progress, [])
  },
  methods: {
    async save () {
      if (!this.IsValidform) {
        // scroll to top
        return $('html, body').animate({ scrollTop: 0 }, 'slow')
      }

      let dataSet = {
        'shop_name': this.form.shop_name,
        'logo': {
          'original': this.form.logo[0].location,
          'thumbnail': this.form.logo[1].location,
        },
        'business': {
          'form_id': this.form.info.business.form_id != '' ? parseInt(this.form.info.business.form_id) : null,
          'type_id': this.form.info.business.type_id != '' ? parseInt(this.form.info.business.type_id) : null,
          'about': this.form.info.business.about.trim() || null,
        },
        'vat': {
          'is_active': this.form.info.vat.is_active,
          'taxpayer_no': this.form.info.vat.taxpayer_no.trim() || null,
        },
        'location': {
          // "lat": this.form.info.location.lat,
          // "lng": this.form.info.location.lng,
          'country_code': this.form.info.location.country_code != '' ? this.form.info.location.country_code : null,
          'address': this.form.info.location.address.trim() || null,
        },
        'contacts': this.dataSetContacts,
      }

      let res = await this.$store.dispatch('updateShop', dataSet)

      if (res.success) {
        // show notify
        this.notify(this.$vs, {
          text: this.$t('message.saved'),
          color: 'success',
          icon: 'cloud',
        })
        // set edited
        this.edited = false
        // set updated
        this.updated = true
        // set data
        this.setData()
        // loading finish
        this.showFinish(this.$Progress)
        // scroll to top
        $('html, body').animate({ scrollTop: 0 }, 'slow')

        this.$nextTick(() => {
          // set edited
          this.edited = true
        })
      }
    },
    onkeyupShopname () {
      this.IsValidform
    },
    setData () {
      let shopInfo = this.shopInfo
      let shopInfoContacts = this.getShopContact(shopInfo.contacts)
      let form = this.form

      // set from
      form.shop_name = shopInfo.shop_name

      form.logo[0].location = shopInfo.logo.original
      form.logo[1].location = shopInfo.logo.thumbnail

      form.info.business.form_id = shopInfo.info.business.form_id || ''
      form.info.business.type_id = shopInfo.info.business.type_id || ''

      form.info.business.about = shopInfo.info.business.about || ''

      form.info.vat.is_active = shopInfo.info.vat.is_active
      form.info.vat.taxpayer_no = shopInfo.info.vat.taxpayer_no || ''

      form.info.location.lat = shopInfo.info.location.lat
      form.info.location.lng = shopInfo.info.location.lng
      form.info.location.country_code = shopInfo.info.location.country_code || ''
      form.info.location.address = shopInfo.info.location.address || ''

      form.contacts.email = shopInfoContacts.email
      form.contacts.tel = shopInfoContacts.tel
      form.contacts.website = shopInfoContacts.website
      form.contacts.facebook = shopInfoContacts.facebook
      form.contacts.youtube = shopInfoContacts.youtube

      if (shopInfo.logo.original == null) {
        form.isShowFilePond = true
      } else {
        form.isShowFilePond = false
      }

      // set originalForm
      this.originalForm = _.cloneDeep(form)
    },
    handleFilePondInit: function () {

    },
    async process  (fieldName, file, metadata, load, error, progress, abort) {
      var that = this

      this.disabled.btn_save = true

      try {
        progress(true, 0, 1024)

        var formData = new FormData()
        formData.append(fieldName, file, file.name)

        let res = await that.$store.dispatch('uploadImage', formData)

        if (!res.success) {
          error(res.error)
        }

        res.data.map(img => {
          if (img.type == 'original') {
            that.form.logo[0].location = img.location
          }
          if (img.type == 'thumbnail') {
            that.form.logo[1].location = img.location
          }
        })

        load('success')

        this.disabled.btn_save = false

        return { abort: () => { abort() } }
      } catch (e) {
        return { abort: () => { abort() } }
      }
    },
    async revert (uniqueFileId, load, error) {
      this.checkToDeleteS3Images()
      this.disabled.btn_save = true
    },
    load (uniqueFileId, load, error) {
      error()
    },
    fetch (url, load, error, progress, abort, headers) {
      error('Solo archivos locales')
    },
    restore (uniqueFileId, load, error, progress, abort, headers) {
      error()
    },
    async checkToDeleteS3Images () {
      if (!this.form.logo[0].location && !this.form.logo[1].location) {
        return false
      }

      var dataSet = {
        'bucket': null,
        'objects': [],
      }

      this.form.logo.map((img, idx) => {
        let bucket = this.getS3Bucket(img.location)
        let key = this.getS3Key(img.location)

        if (!dataSet.bucket) {
          dataSet.bucket = bucket
        }

        dataSet.objects.push({
          'key': key,
        })
      })

      let res = await this.$store.dispatch('deleteImage', dataSet)

      // set images location to null
      this.form.logo[0].location = null
      this.form.logo[1].location = null
    },
    closeImage () {
      this.form.isShowFilePond = true
      this.form.logo[0].location = null
      this.form.logo[1].location = null
    },
  },
}
</script>

<style scoped>
  .box-input {
    position: relative;
    padding-left: 7px;
    height: 35px;
    background: #fff;
    border: 1px solid #ced4da;
    color: #495057;
    line-height: 35px;
    border-radius: .25rem;
    display: inline-block;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .box-input.active {
    background: #e9ecef;
    border-radius: 0 .25rem .25rem 0;
  }
  .btn-close-image {
    margin-right: 10px;
    margin-top: 5px;
    padding: 0;
    border-radius: 100%;
    height: 25px;
    width: 25px;
    background-color: rgba(0,0,0,.7);
    color: #fff;
  }
  .btn-close-image:hover {
    border: solid 2px #fff;
  }
  .btn-close-image i {
    font-size: 11px;
  }
</style>



// WEBPACK FOOTER //
// src/components/apps/settings/company/All.vue